import { render, staticRenderFns } from "./distributionGoodsList.vue?vue&type=template&id=525d7257&scoped=true&"
import script from "./distributionGoodsList.vue?vue&type=script&lang=js&"
export * from "./distributionGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./distributionGoodsList.vue?vue&type=style&index=0&id=525d7257&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d7257",
  null
  
)

export default component.exports